export async function acknowledgeEvents(workspaceId: string, eventIds: string[]): Promise<void> {
    const response = await fetch("/query/activity/acknowledge", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ workspaceId, eventIds })
    });

    if (!response.ok) {
        throw new Error(`ActivityApiError: ${response.status}`);
    }
}

export default { acknowledgeEvents };
